import { render, staticRenderFns } from "./testimonial-page.vue?vue&type=template&id=6eac5c48&"
import script from "./testimonial-page.ts?vue&type=script&lang=ts&"
export * from "./testimonial-page.ts?vue&type=script&lang=ts&"
import style0 from "./testimonial-page.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports